export const handleClass = Object.freeze({
  web: "ui-resizable-handle slot-resizable-handle",
  mobile: "ui-resizable-handle slot-resizable-handle slot-resizable-handle-mobile"
})

export const config = {
  handles: "e, w",
  autoHide: true,
  minWidth: 9,
  classes: {
    "ui-resizable-handle": handleClass.web
  }
};

